import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'

const LockerCodedColumn = ({ value, rowData }) => {
  const [selected, setSelected] = useState(value)
  const dispacth = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setSelected(value)
  }, [value])

  const currentRow = useSelector((state) => state.CMS.currentRow)

  const onApprove = () => {
    let payload = {
      item_date_time_id: currentRow?.[0]?.id,
      item_id: rowData?.id,
      coded: !selected,
    }
    setSelected(!selected)
    setIsLoading(true)
    request('renewal-locations/approve-locker-code', 'POST', payload).then((res) => {
      isSuccessResponse(res, 'Locker coded successfully!')
      setIsLoading(false)
      dispacth(fetchUpdateApiData())
    })
  }
  return (
    <div className='d-flex justify-content-center align-items-center'>
      <input
        type='checkbox'
        checked={selected}
        onChange={() => {
          onApprove()
        }}
      />
    </div>
  )
}

export default LockerCodedColumn
